import { Button } from '@wheely/ui-kit';
import React from 'react';
import { Control } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { TUpdateOwnDriverInfoForm } from '@/modules/driver/model/driver';
import { BottomButtons } from '@/shared/view/BottomButtons';
import { TextField } from '@src-common/view/adapters/reactHookForm/TextField';
import { IDocsListItem } from '@src-common/view/components/DocsList';

import { ProfileDocsList } from '../ProfileDocsList';

import { messages } from './messages';

export type EditDriverInfoProps<T extends IDocsListItem> = {
  control: Control<TUpdateOwnDriverInfoForm>;
  isSubmitting?: boolean;
  onSubmit: (e?: React.BaseSyntheticEvent) => void;
  docs: T[];
  onUploadDoc: (event: React.SyntheticEvent, document: T) => void;
};

export const EditDriverInfo = <T extends IDocsListItem>({
  onSubmit,
  control,
  isSubmitting,
  docs,
  onUploadDoc,
}: EditDriverInfoProps<T>) => {
  const intl = useIntl();

  return (
    <form onSubmit={onSubmit}>
      <TextField
        name="licenseNumber"
        title={intl.formatMessage(messages.driverLicenseTitle)}
        control={control}
        isRequired={true}
      />
      <TextField
        name="homeAddress"
        title={intl.formatMessage(messages.addressTitle)}
        control={control}
        isRequired={false}
      />

      <ProfileDocsList<T> onUploadDoc={onUploadDoc} docs={docs} />

      <BottomButtons>
        <Button type="submit" disabled={isSubmitting}>
          <FormattedMessage defaultMessage="Save" id="RT8KNi" description="Save button text" />
        </Button>
      </BottomButtons>
    </form>
  );
};
